module.exports = {
  "/": {
    "name": "index",
    "success": {
      "landing page loaded": [
        "INDEX_LOAD"
      ]
    }
  },
  "/start": {
    "name": "start",
    "success": {
      "first step loaded": [
        "STEP_1"
      ]
    }
  },
  "/customize": {
    "name": "customize",
    "success": {
      "second step loaded": [
        "STEP_2"
      ]
    }
  },
  "/style": {
    "name": "style",
    "success": {
      "third step loaded": [
        "STEP_3"
      ]
    }
  },
  "/:portalId/create": {
    "name": "create",
    "success": {
      "create page loaded": [
        "CREATE_LOAD"
      ]
    }
  }
};